import type { Review } from "../../constants/reviews";

export default function ReviewCard({ review }: ReviewCardProps) {
  const { content, image, name } = review;

  return (
    <div className="flex flex-col items-center gap-10 max-w-5xl mx-auto">
      <div className="text-center text-2xl sm:text-[46px] font-medium leading-tight tracking-tight sm:text-4xl lg:text-5xl px-4 lg:px-0">
        {content}
      </div>

      <div className="flex flex-col items-center gap-3">
        <img
          src={image}
          alt={name}
          className="size-20 rounded-xl object-cover object-top"
        />

        <div className="flex flex-col items-center gap-1">
          <h4 className="text-foreground text-center text-sm sm:text-lg font-semibold">{name}</h4>
        </div>
      </div>
    </div>
  );
}

interface ReviewCardProps {
  review: Review;
}
